export default __webpack_public_path__ + "static/media/tv7.76cc14b7.jpeg";